import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss']
})
export class SearchBarComponent
{
  @Input() placeholder: string = 'Search';
  @Input() clearFunction: () => void;
  @Input() disabled: boolean;
  @Output() search: EventEmitter<string> = new EventEmitter<string>();
  searchText: string = '';

  onSearch()
  {
    if (!this.disabled)
    {
      this.search.emit(this.searchText);
    }
  }

  clear()
  {
    if (this.clearFunction)
    {
      this.searchText = '';
      this.clearFunction();
    } 
    else
    {
      this.searchText = '';
    }
  }

}
